import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ColorLensIcon(props: IconProps) {
    return <Icon {...props} iconKey={"color_lens"}/>
}
